import { AuthStateAction, AuthStateActions, AuthStateProps } from "./types";

export const initialState: AuthStateProps = {
  isUserAuthorized: false,
  isManufacturer: false,
  authToken: "",
  defaultView: "",
  userData: null,
  sub_header: null,
  isRestoreCalled: false,
  reinvestigation:false,
  eob_warehouse: false,
  upload_eob: false,
  cep_popup: false,
  new_baa_user_1_2: false,
  outreach: false,
  pcc_outreach: false,
};

export const authContextReducer = (state: AuthStateProps, action: AuthStateAction): AuthStateProps => {
  switch (action.type) {
    case AuthStateActions.SET_SESSION:
      return {
        ...state,
        ...action.payload,
      };

    case AuthStateActions.UPDATE_USER_DATA:
      return {
        ...state,
        userData: action.payload.userData,
        defaultView: action.payload.defaultView,
        reinvestigation:action.payload.reinvestigation,
        isManufacturer:action.payload.isManufacturer,
        new_baa_user_1_2: action.payload.new_baa_user_1_2,
        outreach: action.payload.outreach,
        pcc_outreach: action.payload.pcc_outreach,
      };

    case AuthStateActions.UPDATE_USER_TOKEN:
      return {
        ...state,
        authToken: action.payload,
      };

    case AuthStateActions.CLEAR_SESSION:
      return initialState;

    default:
      return state;
  }
};
